<p>inventorymanage works!</p>
